module.exports = __webpack_public_path__ + "static/main_text_ja-0a0804173855381f0adcb57ed6f58318.svg";